import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgUserFollowing = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.6305 12.7215C21.843 12.9177 21.9768 13.1973 21.9973 13.4983C22.0175 13.7976 21.9249 14.092 21.7445 14.3166L17.361 19.8478C17.1545 20.1082 16.854 20.2555 16.5387 20.261C16.2068 20.261 15.9115 20.1219 15.7036 19.8754L13.5797 17.3616C13.3854 17.1322 13.2935 16.8399 13.3054 16.5515C13.3173 16.2618 13.434 15.9783 13.6474 15.7668C13.8743 15.5427 14.1644 15.4425 14.448 15.4565C14.7298 15.4703 15.0089 15.5972 15.2147 15.8411L16.4946 17.3556L20.0627 12.8535C20.2525 12.6111 20.5262 12.4634 20.8167 12.439C21.1111 12.4128 21.4059 12.5132 21.6305 12.7215ZM5.86645 12.4093C6.93062 13.3222 8.31396 13.8736 9.82609 13.8736C10.7116 13.8736 11.553 13.6844 12.3121 13.3444C11.2936 15.4348 11.2888 18.2383 12.4725 20.1274C7.91581 20.606 2 19.8018 2 17.7141C2 15.4533 3.55295 13.4775 5.86645 12.4093ZM9.82609 3.73926C12.2273 3.73926 14.1739 5.68585 14.1739 8.08708C14.1739 10.4883 12.2273 12.4349 9.82609 12.4349C7.42485 12.4349 5.47826 10.4883 5.47826 8.08708C5.47826 5.68585 7.42485 3.73926 9.82609 3.73926Z", fill: props.fill }));
});
export default SvgUserFollowing;
